import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Table from "../components/Table";
import HttpDataSource from "../api/HttpDataSource";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { dateConverter } from "../libs/utility";
import MessageBlock from "../components/MessageBlock";

class DocumentsAchetesUtilisateursList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      documentsUtilisateurs: [],
      originalDocumentsUtilisateurs: [],
      searchDocumentsUtilisateurs: "",
      appliedSearch: "",
      showMore: false,
      page: 1,
      pageSize: 50,
      totalCount: 0,
      errorMessage: ""
    };
  }

  processRows = (rows) => {
    return rows.map((x) => {
      let total = x.quantite * x.prix;
      x.total = Number(Math.round(total + "e2") + "e-2").toFixed(2);
      return x;
    });
  };

  async fetchPage(page) {
    const userGroup = window.localStorage.getItem("userGroup");

    const data = await HttpDataSource.getDocumentsAchetesUtilisateursData(
      this.props.userGroup || userGroup,
      this.props.idPublisher,
      page,
      this.state.pageSize,
      this.state.appliedSearch
    );

    let documentsUtilisateurs = this.processRows(data.result || []);

    this.setState({
      documentsUtilisateurs,
      originalDocumentsUtilisateurs: documentsUtilisateurs,
      page,
      totalCount: data.totalCount || 0,
      showMore: false
    });
  }

  handlePageChange = (page) => {
    this.setState({ isLoading: true }, () => {
      this.fetchPage(page).then(() => {
        this.setState({ isLoading: false });
        window && window.scroll(0, 0);
      });
    });
  };

  async componentDidMount() {
    window && window.scroll(0, 0);
    let documentsUtilisateurs = [];
    let options = { position: "bottom-right" };
    const userGroup = window.localStorage.getItem("userGroup");
    try {
      if (this.props.boardTable) {
        const data = await HttpDataSource.getDocumentsAchetesUtilisateursData(
          this.props.userGroup || userGroup,
          this.props.idPublisher
        );

        documentsUtilisateurs = this.processRows(data.result || []);

        let data_length = documentsUtilisateurs.length;

        this.setState({
          documentsUtilisateurs: documentsUtilisateurs.slice(0, 10),
          originalDocumentsUtilisateurs: documentsUtilisateurs.slice(0, 10),
          isLoading: false,
          showMore: data_length > 10
        });
      } else {
        await this.fetchPage(1);
        this.setState({ isLoading: false });
      }
    } catch (error) {
      let message = "";
      if (error.message) {
        message = error.message + "!,please contact the site administrador";
      } else {
        message =
          error.response.data.error + "!,please contact the site administrador";
      }
      toast.error(this.props.t(message), options);
      this.setState({
        errorMessage: message
      });
    }
  }

  onChange = (e) => {
    const term = e.target.value;
    this.setState({ searchDocumentsUtilisateurs: term });
    if (term === "" && this.state.appliedSearch) {
      this.setState({ appliedSearch: "", isLoading: true }, () => {
        this.fetchPage(1).then(() => this.setState({ isLoading: false }));
      });
    }
  };

  handleSearchKey = (e) => {
    if (e.key === "Enter") {
      const term = e.target.value.trim();
      this.setState({ appliedSearch: term, isLoading: true }, () => {
        this.fetchPage(1).then(() => {
          this.setState({ isLoading: false });
        });
      });
    }
  };

  render() {
    const { t } = this.props;

    this.columns = [
      {
        dataField: "titre",
        text: t("Titre du produit"),
        classes:
          "px-5 py-4 text-left border-b border-gray-200 text-md leading-5 text-donaPurple underline font-bold",
        sort: this.props.boardTable ? false : true,
        headerClasses: "w-64 text-donaPurple font-bold",
        headerAttrs: { scope: "col", tabIndex: this.props.boardTable ? -1 : 0 },
        attrs: { role: "rowheader", scope: "row" },
        formatter: (cell, row) => (
          <Link
            to={`/historique-achats-produits-details/${row.id_commande_produit}`}
          >
            {row.titre}
          </Link>
        )
      },
      {
        dataField: "isbn_issn",
        text: t("Identifiant"),
        classes:
          "px-5 py-4 text-center whitespace-no-wrap border-b border-gray-200 text-md leading-5 text-black",
        sort: this.props.boardTable ? false : true,
        headerClasses: "w-32 text-donaPurple font-bold",
        headerAttrs: { scope: "col", tabIndex: this.props.boardTable ? -1 : 0 }
      },
      {
        dataField: "date_et_heure",
        text: t("Date"),
        headerClasses: "w-40 whitespace-no-wrap text-donaPurple font-bold",
        headerAttrs: { scope: "col", tabIndex: this.props.boardTable ? -1 : 0 },
        classes:
          "px-5 py-4 text-center whitespace-no-wrap border-b border-gray-200 text-md leading-5 text-black",
        formatter: (cell, row) => (
          <span>{dateConverter(row.date_et_heure)}</span>
        ),
        sort: this.props.boardTable ? false : true
      },
      {
        dataField: "nom_org.nom",
        text: t("Maison d'édition"),
        classes:
          "px-5 py-4 text-center whitespace-no-wrap border-b border-gray-200 text-md leading-5 text-black",
        headerClasses: "w-40 whitespace-no-wrap text-donaPurple font-bold",
        headerAttrs: { scope: "col", tabIndex: this.props.boardTable ? -1 : 0 },
        sort: this.props.boardTable ? false : true
      },
      {
        dataField: "quantite",
        text: t("Quantité achetée"),
        classes:
          "px-5 py-4 text-center whitespace-no-wrap border-b border-gray-200 text-md leading-5 text-black",
        headerClasses: "w-20 whitespace-normal text-donaPurple font-bold",
        headerAttrs: { scope: "col", tabIndex: "-1" }
      },
      {
        dataField: "total",
        text: t("Coût total"),
        classes:
          "px-5 py-4 text-center whitespace-no-wrap border-b border-gray-200 text-md leading-5 text-black",
        headerClasses: "w-20 whitespace-normal text-donaPurple font-bold",
        headerAttrs: { scope: "col", tabIndex: "-1" },
        formatter: (cell) => `${cell ? cell + "$" : ""}`
      }
    ];

    const CaptionElement = (
      <>
        {this.props.boardTable ? (
          <div className="flex  justify-between flex-wrap-6 bg-donaPurple p-2 border border-donaPurple rounded">
            <h2 className="text-white font-bold mt-2">
              {t("Historique des achats de mes produits")}
            </h2>
          </div>
        ) : (
          <div className="flex  justify-between flex-wrap-6 bg-donaPurple p-2 border border-donaPurple rounded">
            <h1 className="text-white font-bold mt-2">
              {t("Historique des achats de mes produits")}
            </h1>
            <div
              className="text-white text-left self-center mr-auto pl-1"
              aria-live="polite"
            >
              {this.state.isLoading === false &&
                "(" +
                  this.state.totalCount +
                  " " +
                  (this.state.totalCount > 1
                    ? t("enregistrements")
                    : t("enregistrement")) +
                  ")"}
            </div>
            <div className="relative">
              <FontAwesomeIcon
                icon={faSearch}
                className="absolute pointer-events-none  inset-y-0 ml-3 mt-3 flex items-center"
              />
              <input
                type="search"
                onKeyDown={this.handleSearchKey}
                onChange={this.onChange}
                value={this.state.searchDocumentsUtilisateurs}
                className="bg-white shadow appearance-none border rounded py-2 px-3 text-gray-700 pl-10 leading-tight focus:outline-none focus:shadow-outline"
                placeholder={t("Recherche sur table")}
                aria-label={t("Rechercher dans le tableau")}
              />
            </div>
          </div>
        )}
      </>
    );
    return (
      <>
        {!this.props.boardTable && (
          <Helmet>
            <title>{t("Achats utilisateurs Liste")}</title>
            <meta name="description" content={t("Achats utilisateurs Liste")} />
          </Helmet>
        )}

        {this.state.errorMessage ? (
          <MessageBlock
            alertMessage={this.state.errorMessage}
            className="border px-4 py-3 rounded relative mt-6 mb-2"
            roleType="alert"
          />
        ) : (
          <Table
            keyField="id_commande_produit"
            showMore={this.state.showMore}
            boardTable={this.props.boardTable}
            data={this.state.documentsUtilisateurs}
            caption={CaptionElement}
            columns={this.columns}
            loading={this.state.isLoading}
            classes="table-auto"
            noDataMessage={t("Pas de produits disponible")}
            showMorePagePath="/historique-achats-produits"
            csvFileName={t(
              "historiques_de_mes_produits_achetés_par_les_utilisateurs.csv"
            )}
            t={t}
            page={this.props.boardTable ? undefined : this.state.page}
            pageSize={this.props.boardTable ? undefined : this.state.pageSize}
            totalCount={
              this.props.boardTable ? undefined : this.state.totalCount
            }
            onPageChange={this.handlePageChange}
          />
        )}
      </>
    );
  }
}

DocumentsAchetesUtilisateursList.propTypes = {
  boardTable: PropTypes.bool
};

DocumentsAchetesUtilisateursList.defaultProps = {
  boardTable: false
};

export default DocumentsAchetesUtilisateursList;
